<template>
  <div>
    <div
      v-loading="loadingStatus"
      element-loading-spinner="spinner"
      element-loading-background="rgba(255, 255, 255)">
    </div>
    <slot v-if="!loadingStatus"></slot>
  </div>
</template>

<script>
export default {
  name: 'ContentContainer',
  components: {},
  props: {
    loadingStatus: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
}
</script>
